import * as React from "react";

import { Loader } from "@progress/kendo-react-indicators";
import { getter } from "@progress/kendo-react-common";

import { Toolbar, Button } from "@progress/kendo-react-buttons";
import {
    Grid,
    GridColumn,
    GridSelectionChangeEvent,
    getSelectedState,
} from "@progress/kendo-react-grid";
import { GroupDescriptor } from '@progress/kendo-data-query';

import { useGetReportsQuery } from '../../store/sunbright-api';

export interface EventSummaryGridProps {
    returnLabel: string;
    onReturn?: any;
}

const DATA_ITEM_KEY = "uid";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

const initialGroup: GroupDescriptor[] = [{ field: 'region' }];

const EventSummaryGrid = ({
    returnLabel,
    onReturn,
}: EventSummaryGridProps) => {
    const { data: report, error: reportError, isLoading: reportLoading } = useGetReportsQuery("events");

    const [gridHeight, setGridHeight] = React.useState<string>("600px");

    React.useEffect(() => {
        window.addEventListener("resize", handleResize);
    }, []);
    React.useEffect(() => {
        setGridHeight((window.innerHeight - 120) + "px");
   }, [report]);

    const handleResize = () => {
        setGridHeight((window.innerHeight - 100) + "px");
    };

    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});

    const [selectedUID, setSelectedUID] = React.useState<string>("");

    const handleSelectionChange = (e: GridSelectionChangeEvent) => {
        const newState = getSelectedState({
            event: e,
            selectedState: selectedState,
            dataItemKey: DATA_ITEM_KEY,
        })
        setSelectedState(newState);

        setSelectedUID(Object.keys(newState)[0]);
    };

    return (
        <React.Fragment>
            <div>
                <Toolbar>
                    <Button
                        className="sds-buttoninbar"
                        icon="undo"
                        onClick={(e) => onReturn()}
                    >
                        {returnLabel}
                    </Button>
                    <div style={{ fontSize: "large", fontWeight: "bold", paddingLeft: "64px" }}>
                        Summary April 1, 2024 - March 31, 2025
                    </div>
                </Toolbar>

                {reportError ? (<>Not Authorized</>) : reportLoading ? <Loader size="large" type="converging-spinner" /> : report ?
                    (
                        <Grid
                        style={{ height: gridHeight }}
                        className="eventSummaryGrid"
                        data={report.map((item: any) => ({
                            ...item,
                            [SELECTED_FIELD]: selectedState[idGetter(item)]
                        }))}

                        autoProcessData={true}
                        groupable={true}
                        defaultGroup={initialGroup}

                        resizable={true}
                        size={"small"}
                        dataItemKey={DATA_ITEM_KEY}
                        selectedField={SELECTED_FIELD}
                        selectable={{
                            enabled: true,
                            mode: "single",
                        }}
                        onSelectionChange={handleSelectionChange}
                  >
                        <GridColumn field="region" title="Region" width="0px"/>
                        <GridColumn field="startTime" title="Date" format="{0:MMM d yyyy}" width="95px" />
                        <GridColumn field="type" title="Type" width="185px" />
                        <GridColumn field="host" title="Host/Location" width="257px"  />
                        <GridColumn field="clients" title="Clients" width="58px" />
                        <GridColumn field="pets" title="Pets" width="58px" />
                        <GridColumn field="cats" title="Cats" width="58px" />
                        <GridColumn field="dogs" title="Dogs" width="58px" />
                        <GridColumn field="other" title="Other" width="58px" />
                        <GridColumn field="microchips" title="Microchip" width="90px" />
                        <GridColumn field="vaccinations" title="Vaccination" width="90px" />
                        <GridColumn title="Hours">
                            <GridColumn field="hours349" title="Vet" width="80px" />
                            <GridColumn field="hours350" title="Assist" width="80px" />
                            <GridColumn field="hours351" title="OneHealth" width="80px" />
                            <GridColumn field="hours352" title="Admin" width="80px" />
                            <GridColumn field="hours353" title="Director" width="80px" />
                        </GridColumn>
                        <GridColumn title="One Health Visits">
                            <GridColumn field="oh354" title="Smoking" width="80px" />
                            <GridColumn field="oh355" title="Dental" width="80px" />
                            <GridColumn field="oh356" title="Harm Reduction" width="80px" />
                            <GridColumn field="oh365" title="Mental Health" width="80px" />
                            <GridColumn field="oh366" title="Hand Care" width="80px" />
                            <GridColumn field="oh370" title="Vision" width="80px" />
                            <GridColumn field="oh371" title="Legal" width="80px" />
                            <GridColumn field="oh357" title="Influenza" width="80px" />
                            <GridColumn field="oh358" title="COVID" width="80px" />
                            <GridColumn field="oh359" title="Other Immunization" width="80px" />
                            <GridColumn field="oh360" title="Nursing" width="80px" />
                            <GridColumn field="oh361" title="Sexual Health" width="80px" />
                            <GridColumn field="oh362" title="Healthy Eating" width="80px" />
                            <GridColumn field="oh363" title="Active Living" width="80px" />
                            <GridColumn field="oh364" title="Social Services" width="80px" />
                            <GridColumn field="oh367" title="Foot Care" width="80px" />
                            <GridColumn field="oh368" title="Hair Cuts" width="80px" />
                            <GridColumn field="oh369" title="Tax Prep" width="80px" />
                        </GridColumn>
                    </Grid>) : null}
                </div>
        </React.Fragment>
    );
}
export default EventSummaryGrid;